import { render } from "./JobSyncMappingTab.vue?vue&type=template&id=7708173a&scoped=true"
import script from "./JobSyncMappingTab.vue?vue&type=script&lang=js"
export * from "./JobSyncMappingTab.vue?vue&type=script&lang=js"

import "./JobSyncMappingTab.vue?vue&type=style&index=0&id=7708173a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7708173a"]])

export default __exports__